//@ts-nocheck

'use client'

import React, { useContext } from 'react'
import { ColorSchemeTypes } from '../../../types/ColorScheme'
import { CtaTypes } from '../../../types/Cta'
import { TypographyTypes } from '../../../types/Typography'
import { SectionThemeContext } from '../../../contexts/SectionTheme.context'
import { Container } from '../../atoms/GridSystem'

import TextRichText from './variants/TextRichText.component'
import TextHeadingLight from './variants/TextHeadingLight.component'
import TextHeadingBig from './variants/TextHeadingBig.component'
import TextColumns from './variants/TextColumns.component'
import TextQuote from './variants/TextQuote.component'
import TextWithImage from './variants/TextWithImage.component'

import * as S from './Text.styles'

type TextVariant = 'TextRichText' | 'TextHeadingLight' | 'TextHeadingBig' | 'TextColumns' | 'TextQuote' | 'TextWithImage'
type TextAlignment = 'left' | 'center'

interface TextProps {
  type: TextVariant
  sectionId?: string
  colorScheme?: ColorSchemeTypes
  alignment?: TextAlignment
  twoColumns?: boolean
  body?: any[]
  preTitle?: TypographyTypes
  sectionTitle?: TypographyTypes
  subtitle?: TypographyTypes
  ctaPrimary?: CtaTypes
  ctaSecondary?: CtaTypes
  quote?: string
  author?: string
  columnLeft?: string
  columnRight?: string
  removeBottomPadding?: boolean
  withBackground?: boolean
}

const Text: React.FC<TextProps> = ({ sectionId, type, removeBottomPadding, withBackground, ...props }) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  const dispatcher = {
    TextRichText,
    TextHeadingLight,
    TextHeadingBig,
    TextColumns,
    TextQuote,
    TextWithImage
  }

  const Component = dispatcher[type]

  return Component ? (
    <S.Text 
      colorScheme={selectedColorScheme} 
      variant={type} 
      as="section" 
      id={sectionId} 
      removeBottomPadding={removeBottomPadding}
      withBackground={withBackground}
    >
      <Container>
        <Component {...props} withBackground={withBackground} />
      </Container>
    </S.Text>
  ) : null
}

export default Text
